<template>
  <!-- <div class="c-open-item"> -->
    <p class="link" @click="handleOpen">
      <span class="link__label"> {{ label }}<img class="link__icon" src="@/assets/icon/icon_link.svg" /></span>
    </p>
  <!-- </div> -->
</template>
<script>
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'OpenItem',
  props: {
    label: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const router = useRouter();
    const handleOpen = () => {
      if (props.type === 'internal') {
        router.push(props.link);

        return;
      }

      window.open(props.link);
    };

    return {
      handleOpen,
    };
  },
});
</script>
<style lang="scss" scoped>

.c-open-item {
  display: inline;

}
.link {
  // @include flex();
  display: inline-block;
  cursor: pointer;

  &__label {
    display: inline-block;
    @include font-normal();
    text-decoration: underline;
      cursor: pointer;
      line-height: 30px;
  }

  &__icon {
    display: inline-block;
    margin-left: 10px;
  }

}

</style>
